var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcomButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(90 23.5 0.5)",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8028 16.4733C13.8653 16.4113 13.9149 16.3376 13.9487 16.2563C13.9826 16.1751 14 16.0879 14 15.9999C14 15.9119 13.9826 15.8248 13.9487 15.7435C13.9149 15.6623 13.8653 15.5886 13.8028 15.5266L10.7495 12.4733C10.687 12.4113 10.6374 12.3376 10.6035 12.2563C10.5697 12.1751 10.5523 12.0879 10.5523 11.9999C10.5523 11.9119 10.5697 11.8248 10.6035 11.7435C10.6374 11.6623 10.687 11.5886 10.7495 11.5266L13.8028 8.47326C13.8653 8.41129 13.9149 8.33755 13.9487 8.25631C13.9826 8.17507 14 8.08794 14 7.99993C14 7.91192 13.9826 7.82478 13.9487 7.74354C13.9149 7.6623 13.8653 7.58857 13.8028 7.52659C13.6779 7.40243 13.5089 7.33273 13.3328 7.33273C13.1567 7.33273 12.9877 7.40243 12.8628 7.52659L9.80281 10.5866C9.42828 10.9616 9.2179 11.4699 9.2179 11.9999C9.2179 12.5299 9.42828 13.0383 9.80281 13.4133L12.8628 16.4733C12.9877 16.5974 13.1567 16.6671 13.3328 16.6671C13.5089 16.6671 13.6779 16.5974 13.8028 16.4733Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcomButton);
export default __webpack_public_path__ + "static/media/IcomButton.ec239b9b00fe2b79d90bb6df0e3af9be.svg";
export { ForwardRef as ReactComponent };